module.exports = __webpack_public_path__ + "static/media/NotoSansCJKjp-Medium.76f59350.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/noto-sans-jp/NotoSansCJKjp-Medium.otf
// module id = 414
// module chunks = 0